<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse navText="数据看板" :to="{ name: 'Dashboard' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="账号管理" :to="{ name: 'Users' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>
      <!--
      <li class="nav-item">
        <sidenav-collapse navText="商户管理" :to="{ name: 'Merchants' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>-->
      <li class="nav-item">
        <sidenav-collapse
          :navText="isSubMenuOpen ? '商户管理' : '商户管理>>'"
          :to="{ name: 'Merchants' }"
          @click="toggleSubMenu"
        >
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
        <!-- 二级菜单: 进件管理 -->
        <ul v-if="isSubMenuOpen" class="nav flex-column ms-3">
          <li class="nav-item">
            <sidenav-collapse navText="进件管理" :to="{ name: 'Submission' }">
              <template #icon>
                <basket />
              </template>
            </sidenav-collapse>
          </li>
          <li class="nav-item">
            <sidenav-collapse navText="子账号管理" :to="{ name: 'SubUsers' }">
              <template #icon>
                <basket />
              </template>
            </sidenav-collapse>
          </li>
        </ul>
      </li>

      <li class="nav-item">
        <sidenav-collapse navText="经营数据" :to="{ name: 'Statistic' }">
          <template #icon>
            <spaceship />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="设备管理" :to="{ name: 'Devices' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          其他
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="平台简介" :to="{ name: 'Profile' }">
          <template #icon>
            <customer-support />
          </template>
        </sidenav-collapse>
      </li>
     <li class="nav-item">
        <sidenav-collapse navText="后台账号" :to="{ name: 'Administrators' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <!--  
      <li class="nav-item">
        <sidenav-collapse navText="Sign Up" :to="{ name: 'Sign Up' }">
          <template #icon>
            <spaceship />
          </template>
        </sidenav-collapse>
      </li> -->
    </ul>
  </div>

  <!--<div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
      route="https://www.creative-tim.com/learning-lab/vue/overview/soft-ui-dashboard/"
      label="Documentation"
      icon="ni ni-diamond"
    />
    <a
      class="btn bg-gradient-success mt-4 w-100"
      href="https://www.creative-tim.com/product/vue-soft-ui-dashboard-pro?ref=vsud"
      type="button"
      >Upgrade to pro</a
    >
  </div> -->
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
//import SidenavCard from "./SidenavCard.vue";
import Shop from "../../components/Icon/Shop.vue";
import Office from "../../components/Icon/Office.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
//import Box3d from "../../components/Icon/Box3d.vue";
import Basket from "../../components/Icon/Basket.vue";
//import Lights from "../../components/Icon/Lights.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Document from "../../components/Icon/Document.vue";
import Spaceship from "../../components/Icon/Spaceship.vue";
//import Lights from "../../components/Icon/Lights.vue";
import Settings from "../../components/Icon/Settings.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "金付宝后台管理系统",
      controls: "dashboardsExamples",
      isActive: "active",
      isSubMenuOpen: false, // 控制子菜单展开和折叠
    };
  },
  components: {
    SidenavCollapse,
    //SidenavCard,
    Shop,
    Office,
    CreditCard,
    //Box3d,
    Basket,
    //Lights,
    CustomerSupport,
    Document,
    Spaceship,
    //Lights,
    Settings,
  },
  methods: {
    toggleSubMenu() {
      this.isSubMenuOpen = !this.isSubMenuOpen;
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
};
</script>
